import React from 'react'
import professorJournal from './professorJournal.pdf'

function Download() {
    return (
        <>
            <h2>Download The Professor's Journal</h2>
            <a href={professorJournal} download>
                <button className="landing_btn">Download</button>
            </a>
        </>
    )
}

export default Download